import { createRoot } from 'react-dom/client'
import 'dayjs/locale/nl'
import { App } from './App'
import './i18n'

/* eslint-disable  @typescript-eslint/no-explicit-any */
declare global {
  interface Window {
    Cypress: any
    grecaptcha: any
  }
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace NodeJS {
    interface Global {
      __REDUX_DEVTOOLS_EXTENSION__: any
    }
  }
}

const container = document.getElementById('root')
if (container) {
  const root = createRoot(container)
  root.render(<App />)
}
